import * as teamManagementApi from '@apis/team-management/teamManagementApi';
import {
  createNgApiAdapterService,
  GetNgApiAdapterType,
} from './createNgApiAdapter';

// Adapting the names to match the legacy service interface here
const teamManagementApiService = createNgApiAdapterService({
  addUserAsync: teamManagementApi.addUser,
  deleteUserAsync: teamManagementApi.deleteUser,
  getAllClientsAsync: teamManagementApi.getAllClients,
  getAllUsersAsync: teamManagementApi.getAllUsers,
  getUserAsync: teamManagementApi.getUser,
  updateUserAsync: teamManagementApi.updateUser,
});
export type TeamManagementApiService = GetNgApiAdapterType<
  typeof teamManagementApiService
>;
// Backwards compatibility: Use the old service name
angular
  .module('curalate')
  .service('TeamManagementService', teamManagementApiService);
